var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2372_55012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.344 0H5.656C2.5305 0 0 2.5305 0 5.656V22.3475C0 25.4695 2.5305 28 5.656 28H22.3475C25.4695 28 28.0035 25.4695 28.0035 22.344V5.656C28 2.5305 25.4695 0 22.344 0Z",
    fill: "url(#paint0_linear_2372_55012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8805 6.43315L14.4475 5.45315C14.7975 4.84065 15.578 4.63415 16.1905 4.98415C16.803 5.33415 17.0095 6.11465 16.6595 6.72715L11.196 16.1841H15.1475C16.4285 16.1841 17.146 17.6891 16.5895 18.7321H5.00447C4.29747 18.7321 3.73047 18.1651 3.73047 17.4581C3.73047 16.7511 4.29747 16.1841 5.00447 16.1841H8.25247L12.4105 8.97765L11.112 6.72365C10.762 6.11115 10.9685 5.33765 11.581 4.98065C12.1935 4.63065 12.967 4.83715 13.324 5.44965L13.8805 6.43315ZM8.96647 20.0446L7.74147 22.1691C7.39147 22.7816 6.61097 22.9881 5.99847 22.6381C5.38597 22.2881 5.17947 21.5076 5.52947 20.8951L6.43947 19.3201C7.46847 19.0016 8.30497 19.2466 8.96647 20.0446ZM19.5155 16.1911H22.83C23.537 16.1911 24.104 16.7581 24.104 17.4651C24.104 18.1721 23.537 18.7391 22.83 18.7391H20.989L22.2315 20.8951C22.5815 21.5076 22.375 22.2811 21.7625 22.6381C21.15 22.9881 20.3765 22.7816 20.0195 22.1691C17.9265 18.5396 16.355 15.8236 15.312 14.0141C14.2445 12.1731 15.0075 10.3251 15.76 9.69865C16.5965 11.1336 17.846 13.3001 19.5155 16.1911Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2372_55012",
    x1: 14.0017,
    y1: 0,
    x2: 14.0017,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18BFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2072F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2372_55012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreLogo);
export default __webpack_public_path__ + "static/media/app-store-logo.404c5a703ecfad5c290d51fb81f90dee.svg";
export { ForwardRef as ReactComponent };